export default {
    baseStyle: {
        row: {
            alignItems: 'flex-start',
            gap: 3,
            borderRadius: 'sm'
        },
        imageContainer: {
            flexShrink: 0,
            width: '95px'
        },
        image: {
            width: '100%',
            height: '100%',
            objectFit: 'cover'
        },
        content: {
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            minWidth: 0,
            gap: 1
        },
        name: {
            textStyle: 'labelXs'
        },
        priceRow: {
            display: 'flex',
            alignItems: 'flex-start'
        }
    }
}
